var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf-download-button"},[_c('a',{attrs:{"href":_vm.pdfLink,"download":""}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" "+_vm._s(_vm.$t('button')))])])}
var staticRenderFns = []

export { render, staticRenderFns }